import React from 'react';
import {Route, Routes} from "react-router-dom";
import DocumentCreateEdit from "./DocumentCreateEdit";
import DocumentList from "./DocumentList";


function DocumentRouter() {

    return (
        <Routes>
            <Route path="" element={<DocumentList />} />
            {/*<Route path=":id" element={<CourseDetail />} />*/}
            <Route path=":id/edit" element={<DocumentCreateEdit />} />
            <Route path="/new" element={<DocumentCreateEdit />} />

        </Routes>
    )
}


export default function Documents() {
    return (
        <DocumentRouter />
    )
}
